/* eslint-disable no-unused-vars */
import React, { useState, useContext } from 'react';
import SelectedCarModel from './SelectedCarModel';
import TimeAndDistance from './TimeAndDistance';
import MaterialSelect from './utils/MaterialSelect';
import useCarsData from '../hooks/useCarsData';

const TimeAndModel = () => {

    const { setSelectedCar, getSelectedCar } = useCarsData();
    const selectedCar = getSelectedCar();

    const handleCarSelect = car => {
        setSelectedCar(car.id);

        // SEO google dataLayer
        dataLayer.push({
            'event': 'trackEvent',
            'eventCategory': 'cotizar_one_personal',
            'eventAction': 'elegir_modelo',
            'eventLabel': car.name
        });
    }

    return (
        <>
            <div className="form-row-group">
                <div className="form-row">
                    <label>Modelo</label>
                    <MaterialSelect onCarSelect={handleCarSelect} defaultText="Selecciona tu Toyota"/>
                </div>
                <div className="form-row model-preview">
                    {selectedCar ? (
                        <div className="model-preview-content">
                            <img src={selectedCar.photo_1.url} alt={selectedCar.name} />
                        </div>
                    ) : (
                        <div className="model-preview-placeholder">
                            <p>Selecciona un modelo</p>
                        </div>
                    )}
                </div>
            </div>

            <TimeAndDistance />
        </>
    );
}

export default TimeAndModel;

